import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CsBuildupStateQuery } from '..';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss']
})
export class SectionComponent implements OnInit, OnDestroy {
  private internalIsAnyInEditMode = false;
  private uiStateSubscription: Subscription;

  public get isAnyInEditMode(): boolean {
    return this.internalIsAnyInEditMode;
  }

  constructor(private element: ElementRef<Element>, private uiStateQuery: CsBuildupStateQuery) { }

  ngOnInit(): void {
    const sectionName = this.element.nativeElement.getAttribute('name');
    this.uiStateSubscription = this.uiStateQuery
      .isAnySectionPartOfSectionInEditMode(sectionName)
      .subscribe(isInEditMode => this.internalIsAnyInEditMode = isInEditMode);
  }

  ngOnDestroy(): void {
    this.uiStateSubscription.unsubscribe();
  }
}
